// extracted by css-extract-rspack-plugin
export default {"root":"ErrorPages-module__root___AXVjz","bordered":"ErrorPages-module__bordered___A1rwW"};